// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Transazioni.css */

.transazioni-page {
  max-width: 750px;
}

.transazioni-page h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--gray-900, #111827);
  margin: 0 0 1.5rem;
}

/* Form */
.transazioni-form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}

.transazioni-tabs {
  display: flex;
  gap: 0.4rem;
}

.transazioni-tab {
  flex: 1 1;
  padding: 0.6rem;
  border: 2px solid var(--gray-200, #e5e7eb);
  border-radius: var(--radius-md, 0.5rem);
  background: #fff;
  cursor: pointer;
  font-size: 0.88rem;
  font-family: inherit;
  transition: all 150ms;
  white-space: nowrap;
}
.transazioni-tab.active {
  border-color: var(--primary-color, #4f46e5);
  background: #eef2ff;
  color: var(--primary-color, #4f46e5);
}

.transazioni-form-row {
  display: flex;
  gap: 0.5rem;
}

.transazioni-input {
  padding: 0.75rem 0.75rem;
  border: 2px solid var(--gray-200, #e5e7eb);
  border-radius: var(--radius-md, 0.5rem);
  font-size: 0.95rem;
  background: #ffffff;
  color: #111827;
  outline: none;
  transition: border-color 150ms;
  font-family: inherit;
  box-sizing: border-box;
}

.transazioni-input:focus {
  border-color: var(--primary-color, #4f46e5);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.transazioni-input-tipo { flex: 1 1; min-width: 100px; cursor: pointer; }
.transazioni-input-portafoglio { flex: 1.5 1; min-width: 120px; cursor: pointer; }
.transazioni-input-importo { flex: 0.8 1; min-width: 90px; }
.transazioni-input-categoria { flex: 1 1; min-width: 120px; cursor: pointer; }
.transazioni-input-descrizione { flex: 2 1; min-width: 130px; }
.transazioni-input-data {
  padding: 0.5rem 0.6rem; border: 1px solid var(--gray-200, #e5e7eb);
  border-radius: 0.375rem; font-size: 0.85rem; font-family: inherit;
  background: #fff; color: #111827; outline: none;
}

.transazioni-add-btn {
  width: 44px;
  height: 44px;
  border: none;
  border-radius: var(--radius-md, 0.5rem);
  background: var(--primary-color, #4f46e5);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 150ms;
}
.transazioni-add-btn:hover { background: var(--primary-hover, #4338ca); }
.transazioni-add-btn svg { width: 22px; height: 22px; }

/* Messaggi */
.transazioni-message {
  padding: 0.75rem 1rem;
  border-radius: var(--radius-md, 0.5rem);
  font-size: 0.875rem;
  margin-bottom: 1rem;
}
.transazioni-message.error { background: #fef2f2; color: #ef4444; border: 1px solid #fecaca; }
.transazioni-message.success { background: #f0fdf4; color: #10b981; border: 1px solid #bbf7d0; }

/* Vuoto */
.transazioni-empty {
  text-align: center; padding: 3rem 1rem; background: #fff;
  border: 2px dashed var(--gray-300, #d1d5db); border-radius: var(--radius-lg, 0.75rem);
}

/* Lista */
.transazioni-list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 0.5rem; }

.transazioni-item {
  display: flex; align-items: center; gap: 0.75rem;
  padding: 0.85rem 1rem; background: #fff;
  border: 1px solid var(--gray-200, #e5e7eb); border-radius: var(--radius-md, 0.5rem);
}

.tr-icon { font-size: 1.3rem; flex-shrink: 0; width: 28px; text-align: center; }
.tr-info { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 0.15rem; }
.tr-desc { font-size: 0.95rem; color: #1f2937; font-weight: 500; }
.tr-meta { font-size: 0.78rem; color: #9ca3af; }
.tr-importo { font-size: 1rem; font-weight: 600; white-space: nowrap; flex-shrink: 0; }
.tr-importo-negativo { color: #ef4444; }
.tr-importo-positivo { color: #10b981; }

/* Edit inline */
.transazioni-edit-row {
  display: flex; align-items: center; gap: 0.4rem; width: 100%; flex-wrap: wrap;
}
.transazioni-edit-row select, .transazioni-edit-row input {
  padding: 0.45rem 0.5rem; border: 2px solid var(--primary-color, #4f46e5);
  border-radius: 0.375rem; font-size: 0.85rem; font-family: inherit;
  background: #fff; color: #111827; outline: none; min-width: 80px;
}
.transazioni-edit-row input[type="number"] { width: 80px; min-width: 70px; }
.transazioni-edit-row input[type="text"] { flex: 1 1; min-width: 90px; }
.transazioni-edit-actions { display: flex; gap: 0.3rem; flex-shrink: 0; }

.transazioni-loading { color: #6b7280; font-size: 1rem; }

/* Barra filtri */
.transazioni-filtri {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem; padding: 0.9rem;
  background: #fff; border: 1px solid var(--gray-200, #e5e7eb);
  border-radius: var(--radius-md, 0.5rem);
  min-width: 0;
}
.transazioni-filtri-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.transazioni-filtri-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #374151;
}
.transazioni-filter-reset {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.7rem;
  border: none; border-radius: 0.375rem;
  background: var(--gray-100, #f3f4f6); color: var(--gray-600, #4b5563);
  cursor: pointer; font-size: 0.8rem; font-family: inherit; font-weight: 600;
  transition: background 150ms;
}
.transazioni-filter-reset:hover { background: var(--gray-200, #e5e7eb); }
.transazioni-filter-reset svg { flex-shrink: 0; }

.transazioni-filtri-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.6rem;
  min-width: 0;
}
.transazioni-filter-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}
.transazioni-filter-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #6b7280;
}
.transazioni-filter-input {
  padding: 0.55rem 0.6rem;
  border: 2px solid var(--gray-200, #e5e7eb);
  border-radius: 0.5rem;
  font-size: 0.88rem;
  font-family: inherit;
  background: #fff; color: #111827;
  outline: none;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  transition: border-color 150ms;
}
.transazioni-filter-input:focus { border-color: var(--primary-color, #4f46e5); }

.tr-nome-utente {
  font-size: 0.72rem;
  color: #7c3aed;
  background: #ede9fe;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  white-space: nowrap;
  flex-shrink: 0;
  text-transform: uppercase; 
}

.tr-nome-utente {
  font-size: 0.72rem;
  color: #7c3aed;
  background: #ede9fe;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  white-space: nowrap;
  flex-shrink: 0;
  text-transform: uppercase; 
  width: 15%;
  display: flex;           
  align-items: center;
  justify-content: center; 
}

.tr-coda {
  width: 15%;
  display: flex;
  gap: 0.3rem;
  align-items: center;
  justify-content: center;
}

.tr-coda button {
  flex-shrink: 0;           /* evita che i bottoni si restringano */
}

/* Mobile */
@media (max-width: 767px) {
  .transazioni-page { max-width: 100%; }
  .transazioni-page h2 { font-size: 1.25rem; }
  .transazioni-form-row { flex-direction: column; }
  .transazioni-input { width: 100%; min-width: 0; }
  .transazioni-add-btn { width: 100%; }
  .transazioni-item { padding: 0.75rem 0.85rem; gap: 0.4rem; }
  .tr-desc { font-size: 0.85rem; }
  .tr-meta { font-size: 0.72rem; }
  .tr-importo { font-size: 0.9rem; }
  .transazioni-filtri-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 379px) {
  .transazioni-filtri-grid { grid-template-columns: 1fr; }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Transazioni.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;EACf,0CAA0C;EAC1C,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA,0BAA0B,SAAO,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACtE,iCAAiC,WAAS,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC/E,6BAA6B,WAAS,EAAE,eAAe,EAAE;AACzD,+BAA+B,SAAO,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC3E,iCAAiC,SAAO,EAAE,gBAAgB,EAAE;AAC5D;EACE,sBAAsB,EAAE,0CAA0C;EAClE,uBAAuB,EAAE,kBAAkB,EAAE,oBAAoB;EACjE,gBAAgB,EAAE,cAAc,EAAE,aAAa;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;AAC9B;AACA,6BAA6B,yCAAyC,EAAE;AACxE,2BAA2B,WAAW,EAAE,YAAY,EAAE;;AAEtD,aAAa;AACb;EACE,qBAAqB;EACrB,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;AACrB;AACA,6BAA6B,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC7F,+BAA+B,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAE/F,UAAU;AACV;EACE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB;EACxD,2CAA2C,EAAE,wCAAwC;AACvF;;AAEA,UAAU;AACV,oBAAoB,gBAAgB,EAAE,UAAU,EAAE,SAAS,EAAE,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;;AAEjH;EACE,aAAa,EAAE,mBAAmB,EAAE,YAAY;EAChD,qBAAqB,EAAE,gBAAgB;EACvC,0CAA0C,EAAE,uCAAuC;AACrF;;AAEA,WAAW,iBAAiB,EAAE,cAAc,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAC/E,WAAW,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACvF,WAAW,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACjE,WAAW,kBAAkB,EAAE,cAAc,EAAE;AAC/C,cAAc,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACtF,uBAAuB,cAAc,EAAE;AACvC,uBAAuB,cAAc,EAAE;;AAEvC,gBAAgB;AAChB;EACE,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,WAAW,EAAE,eAAe;AAC/E;AACA;EACE,uBAAuB,EAAE,+CAA+C;EACxE,uBAAuB,EAAE,kBAAkB,EAAE,oBAAoB;EACjE,gBAAgB,EAAE,cAAc,EAAE,aAAa,EAAE,eAAe;AAClE;AACA,6CAA6C,WAAW,EAAE,eAAe,EAAE;AAC3E,2CAA2C,SAAO,EAAE,eAAe,EAAE;AACrE,4BAA4B,aAAa,EAAE,WAAW,EAAE,cAAc,EAAE;;AAExE,uBAAuB,cAAc,EAAE,eAAe,EAAE;;AAExD,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB,EAAE,eAAe;EACpC,gBAAgB,EAAE,0CAA0C;EAC5D,uCAAuC;EACvC,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,YAAY,EAAE,uBAAuB;EACrC,oCAAoC,EAAE,+BAA+B;EACrE,eAAe,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,gBAAgB;EAC1E,4BAA4B;AAC9B;AACA,kCAAkC,oCAAoC,EAAE;AACxE,gCAAgC,cAAc,EAAE;;AAEhD;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB,EAAE,cAAc;EAChC,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,8BAA8B;AAChC;AACA,kCAAkC,2CAA2C,EAAE;;AAE/E;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc,YAAY,uCAAuC;AACnE;;AAEA,WAAW;AACX;EACE,oBAAoB,eAAe,EAAE;EACrC,uBAAuB,kBAAkB,EAAE;EAC3C,wBAAwB,sBAAsB,EAAE;EAChD,qBAAqB,WAAW,EAAE,YAAY,EAAE;EAChD,uBAAuB,WAAW,EAAE;EACpC,oBAAoB,wBAAwB,EAAE,WAAW,EAAE;EAC3D,WAAW,kBAAkB,EAAE;EAC/B,WAAW,kBAAkB,EAAE;EAC/B,cAAc,iBAAiB,EAAE;EACjC,2BAA2B,qCAAqC,EAAE;AACpE;AACA;EACE,2BAA2B,0BAA0B,EAAE;AACzD","sourcesContent":["/* Transazioni.css */\n\n.transazioni-page {\n  max-width: 750px;\n}\n\n.transazioni-page h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--gray-900, #111827);\n  margin: 0 0 1.5rem;\n}\n\n/* Form */\n.transazioni-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n}\n\n.transazioni-tabs {\n  display: flex;\n  gap: 0.4rem;\n}\n\n.transazioni-tab {\n  flex: 1;\n  padding: 0.6rem;\n  border: 2px solid var(--gray-200, #e5e7eb);\n  border-radius: var(--radius-md, 0.5rem);\n  background: #fff;\n  cursor: pointer;\n  font-size: 0.88rem;\n  font-family: inherit;\n  transition: all 150ms;\n  white-space: nowrap;\n}\n.transazioni-tab.active {\n  border-color: var(--primary-color, #4f46e5);\n  background: #eef2ff;\n  color: var(--primary-color, #4f46e5);\n}\n\n.transazioni-form-row {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.transazioni-input {\n  padding: 0.75rem 0.75rem;\n  border: 2px solid var(--gray-200, #e5e7eb);\n  border-radius: var(--radius-md, 0.5rem);\n  font-size: 0.95rem;\n  background: #ffffff;\n  color: #111827;\n  outline: none;\n  transition: border-color 150ms;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.transazioni-input:focus {\n  border-color: var(--primary-color, #4f46e5);\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.transazioni-input-tipo { flex: 1; min-width: 100px; cursor: pointer; }\n.transazioni-input-portafoglio { flex: 1.5; min-width: 120px; cursor: pointer; }\n.transazioni-input-importo { flex: 0.8; min-width: 90px; }\n.transazioni-input-categoria { flex: 1; min-width: 120px; cursor: pointer; }\n.transazioni-input-descrizione { flex: 2; min-width: 130px; }\n.transazioni-input-data {\n  padding: 0.5rem 0.6rem; border: 1px solid var(--gray-200, #e5e7eb);\n  border-radius: 0.375rem; font-size: 0.85rem; font-family: inherit;\n  background: #fff; color: #111827; outline: none;\n}\n\n.transazioni-add-btn {\n  width: 44px;\n  height: 44px;\n  border: none;\n  border-radius: var(--radius-md, 0.5rem);\n  background: var(--primary-color, #4f46e5);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 150ms;\n}\n.transazioni-add-btn:hover { background: var(--primary-hover, #4338ca); }\n.transazioni-add-btn svg { width: 22px; height: 22px; }\n\n/* Messaggi */\n.transazioni-message {\n  padding: 0.75rem 1rem;\n  border-radius: var(--radius-md, 0.5rem);\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n}\n.transazioni-message.error { background: #fef2f2; color: #ef4444; border: 1px solid #fecaca; }\n.transazioni-message.success { background: #f0fdf4; color: #10b981; border: 1px solid #bbf7d0; }\n\n/* Vuoto */\n.transazioni-empty {\n  text-align: center; padding: 3rem 1rem; background: #fff;\n  border: 2px dashed var(--gray-300, #d1d5db); border-radius: var(--radius-lg, 0.75rem);\n}\n\n/* Lista */\n.transazioni-list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 0.5rem; }\n\n.transazioni-item {\n  display: flex; align-items: center; gap: 0.75rem;\n  padding: 0.85rem 1rem; background: #fff;\n  border: 1px solid var(--gray-200, #e5e7eb); border-radius: var(--radius-md, 0.5rem);\n}\n\n.tr-icon { font-size: 1.3rem; flex-shrink: 0; width: 28px; text-align: center; }\n.tr-info { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 0.15rem; }\n.tr-desc { font-size: 0.95rem; color: #1f2937; font-weight: 500; }\n.tr-meta { font-size: 0.78rem; color: #9ca3af; }\n.tr-importo { font-size: 1rem; font-weight: 600; white-space: nowrap; flex-shrink: 0; }\n.tr-importo-negativo { color: #ef4444; }\n.tr-importo-positivo { color: #10b981; }\n\n/* Edit inline */\n.transazioni-edit-row {\n  display: flex; align-items: center; gap: 0.4rem; width: 100%; flex-wrap: wrap;\n}\n.transazioni-edit-row select, .transazioni-edit-row input {\n  padding: 0.45rem 0.5rem; border: 2px solid var(--primary-color, #4f46e5);\n  border-radius: 0.375rem; font-size: 0.85rem; font-family: inherit;\n  background: #fff; color: #111827; outline: none; min-width: 80px;\n}\n.transazioni-edit-row input[type=\"number\"] { width: 80px; min-width: 70px; }\n.transazioni-edit-row input[type=\"text\"] { flex: 1; min-width: 90px; }\n.transazioni-edit-actions { display: flex; gap: 0.3rem; flex-shrink: 0; }\n\n.transazioni-loading { color: #6b7280; font-size: 1rem; }\n\n/* Barra filtri */\n.transazioni-filtri {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 1rem; padding: 0.9rem;\n  background: #fff; border: 1px solid var(--gray-200, #e5e7eb);\n  border-radius: var(--radius-md, 0.5rem);\n  min-width: 0;\n}\n.transazioni-filtri-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.transazioni-filtri-title {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #374151;\n}\n.transazioni-filter-reset {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.7rem;\n  border: none; border-radius: 0.375rem;\n  background: var(--gray-100, #f3f4f6); color: var(--gray-600, #4b5563);\n  cursor: pointer; font-size: 0.8rem; font-family: inherit; font-weight: 600;\n  transition: background 150ms;\n}\n.transazioni-filter-reset:hover { background: var(--gray-200, #e5e7eb); }\n.transazioni-filter-reset svg { flex-shrink: 0; }\n\n.transazioni-filtri-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.6rem;\n  min-width: 0;\n}\n.transazioni-filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  min-width: 0;\n}\n.transazioni-filter-label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #6b7280;\n}\n.transazioni-filter-input {\n  padding: 0.55rem 0.6rem;\n  border: 2px solid var(--gray-200, #e5e7eb);\n  border-radius: 0.5rem;\n  font-size: 0.88rem;\n  font-family: inherit;\n  background: #fff; color: #111827;\n  outline: none;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n  transition: border-color 150ms;\n}\n.transazioni-filter-input:focus { border-color: var(--primary-color, #4f46e5); }\n\n.tr-nome-utente {\n  font-size: 0.72rem;\n  color: #7c3aed;\n  background: #ede9fe;\n  padding: 0.2rem 0.6rem;\n  border-radius: 999px;\n  white-space: nowrap;\n  flex-shrink: 0;\n  text-transform: uppercase; \n}\n\n.tr-nome-utente {\n  font-size: 0.72rem;\n  color: #7c3aed;\n  background: #ede9fe;\n  padding: 0.2rem 0.6rem;\n  border-radius: 999px;\n  white-space: nowrap;\n  flex-shrink: 0;\n  text-transform: uppercase; \n  width: 15%;\n  display: flex;           \n  align-items: center;\n  justify-content: center; \n}\n\n.tr-coda {\n  width: 15%;\n  display: flex;\n  gap: 0.3rem;\n  align-items: center;\n  justify-content: center;\n}\n\n.tr-coda button {\n  flex-shrink: 0;           /* evita che i bottoni si restringano */\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .transazioni-page { max-width: 100%; }\n  .transazioni-page h2 { font-size: 1.25rem; }\n  .transazioni-form-row { flex-direction: column; }\n  .transazioni-input { width: 100%; min-width: 0; }\n  .transazioni-add-btn { width: 100%; }\n  .transazioni-item { padding: 0.75rem 0.85rem; gap: 0.4rem; }\n  .tr-desc { font-size: 0.85rem; }\n  .tr-meta { font-size: 0.72rem; }\n  .tr-importo { font-size: 0.9rem; }\n  .transazioni-filtri-grid { grid-template-columns: repeat(2, 1fr); }\n}\n@media (max-width: 379px) {\n  .transazioni-filtri-grid { grid-template-columns: 1fr; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
